import { createAction } from 'redux-actions';

const mapActions = {
  TRACK_DEFAULT_HOTEL_CARD_CLICK_WEB: 'TRACK_DEFAULT_HOTEL_CARD_CLICK_WEB',
  TRACK_MARKER_CLICK_WEB: 'TRACK_MARKER_CLICK_WEB',
  TRACK_HOTEL_CARD_CLICK_WEB: 'TRACK_HOTEL_CARD_CLICK_WEB',
};

const actionCreators = {
  trackDefaultHotelCardClickWeb: createAction(
    mapActions.TRACK_DEFAULT_HOTEL_CARD_CLICK_WEB
  ),
  trackMapMarkerClickWeb: createAction(mapActions.TRACK_MARKER_CLICK_WEB),
  trackHotelCardClickWeb: createAction(mapActions.TRACK_HOTEL_CARD_CLICK_WEB),
};

export { mapActions as types, actionCreators };
